<template>
    <EditBase
        v-if="event.provider ? event.provider.includes('survey') : false"
        :show-edit="showEdit"
        :question="question"
        :qNum="qNum"
        :event="event"
        :patient="patient"
        :survey="survey"
        :saving-edit="savingEdit"
        :save-disabled="!enableSave"
        :show-remove-response="showRmvResp"
        :is-mandatory="checkIfMandatory()"
        @response-removed="removeResponse()"
        @save-edit="updateQuestion()"
        @open-dialog="showEdit = true"
        @close-dialog="closePopup()">
        <div class="date inl">
            {{ qDate }}
        </div>
        <div class="inl">
            <template v-if="question.type === 'text'">
                <el-input
                    v-model="updateResponse.answer"
                    @change="onResponseChange()">
                </el-input>
                <span v-if="updateResponse.answer == undefined || updateResponse.answer == null || updateResponse.answer == ''" class="no-answer">
                    Not Answered
                </span>
            </template>
        </div>
    </EditBase>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EditBase from './EditBase'
import QuestionEdit from './'
import { v4 as uuidv4 } from 'uuid'
import response from '../analysis/response'

export default {
    name: 'edit-text',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: this.getQuestionResponse(),
            enableSave: false,
            showRmvResp: !this.checkIfMandatory() && this.response,
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey'
        ]),
        closePopup() {
            this.showEdit = false
            this.enableSave = false
            this.updateResponse = this.getQuestionResponse()
            this.showRmvResp = !this.checkIfMandatory() && this.response
        },
        removeResponse() {
            this.updateResponse.answer = ''
            this.showRmvResp = false
            this.enableSave = this.checkIfMandatory() ? false : true
        },
        onResponseChange() {
            if(this.updateResponse && 
                this.updateResponse.answer && 
                (this.updateResponse.answer != null || this.updateResponse.answer != "")) {
                    this.enableSave = true
                    this.showRmvResp = this.checkIfMandatory() ? false : true
            } else {
                this.enableSave = this.checkIfMandatory() ? false : true
                this.showRmvResp = false
            }
        },
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate()
            else
                update.push(this.getQuestionUpdate())
            
            console.log(update)

            //return
            this.savingEdit = true

            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false
                    this.enableSave = false
                    this.showEdit = false
                    this.showRmvResp = !this.checkIfMandatory() && this.response
                })
        },
        getQuestionResponse() {
            if(this.question.type === 'text' && this.oresponse) {
                let answer = this.oresponse ? this.oresponse[0] : null
                if(answer && answer.id) {
                    return this.oresponse[0]
                } else {
                    return {
                        answer: this.oresponse[0],
                        id: uuidv4()
                    }
                }
            }
            
            return ''
        },
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: null
            }
            if(this.question.type === 'text')
                update.answer = [this.updateResponse]

            return update
        },
    },

    computed: {
    },

    components: {
        EditBase
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';
.multi-question-edit {
    margin-block-start: 20px;
        padding-inline-start: 20px;
}
.sub-question{
    margin-top: 15px;
    margin-bottom: 5px;
}

.el-input {
    margin: 0 10px;
    max-width: 620px;
    min-width: 620px;
    border: 1px solid #EEEEEE;

    ::v-deep input {
        color: #709F34;
        background-color: #F8F8F8;
    }
}
</style>
